<template>
  <div class="content info-text error-message" tabindex="0" ref="firstStep">
    {{messages.errorGeneralMessage}}
    <v-btn
      :ripple="false"
      class="submit back"
      flat
      @click="backToStart"
    >{{messages.backToStartPageButtonText}}</v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ErrorPage',
  props: [
    'focusEventKey'
  ],
  computed: {
    ...mapState([
      'messages'
    ])
  },
  watch: {
    focusEventKey () {
      if (this.funcDebug) console.log('ErrorPage:watch:focusEventKey')
      this.$refs.firstStep.focus()
    }
  },
  methods: {
    backToStart () {
      this.$router.push({
        name: 'booking'
      })
    }
  }
}
</script>

<style lang="scss">
</style>
